export default "__VITE_ASSET__CWESShWj__"